export default class ApiClient {
  constructor(baseUrl) {
    const defaultDomain =
      process.env.NODE_ENV === 'production' ? process.env.APP_DOMAIN : 'http://localhost:3000';
    this.baseUrl = baseUrl || defaultDomain;
  }

  /**
   * Perform a GET request
   * @param {string} endpoint - API endpoint (e.g., "/users")
   * @param {object} options - Optional fetch options (e.g., headers)
   * @returns {Promise<any>} - Parsed JSON response
   */
  async get(endpoint, options = {}) {
    try {
      const response = await fetch(`${this.baseUrl}${endpoint}`, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          ...(options.headers || {}),
        },
        ...options,
      });

      if (!response.ok) {
        throw new Error(`GET ${endpoint} failed: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('API GET error:', error);
      throw error;
    }
  }

  /**
   * Perform a POST request
   * @param {string} endpoint - API endpoint (e.g., "/recommend")
   * @param {object} body - Request payload
   * @param {object} options - Optional fetch options (e.g., headers)
   * @returns {Promise<any>} - Parsed JSON response
   */
  async post(endpoint, body = {}, options = {}) {
    try {
      const response = await fetch(`${this.baseUrl}${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          ...(options.headers || {}),
        },
        body: JSON.stringify(body),
        ...options,
      });

      if (!response.ok) {
        throw new Error(`POST ${endpoint} failed: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('API POST error:', error);
      throw error;
    }
  }
}
